<template>
  <v-card flat>
    <v-container>
    <div v-if="foods.length>0" style="margin-bottom:10px;">
      <h2 style="text-align:left;margin-bottom:10px;">
        {{headline}}の辛い食品
      </h2>
      <v-layout row wrap>
        <v-flex xs6
          v-for="(f, id) in foods" :key=id
          @click="$router.push({name: 'searchFoodDetail', params: {id: f.id}})"
        >
          <food-card-image
            :food=f
          >
          </food-card-image>
        </v-flex>
      </v-layout>
    </div>
    </v-container>
  </v-card>
</template>

<script>
import {db} from '@/main'
import FoodCardImage from '@/components/card/FoodCardImage.vue'

export default {
  name: 'FoodCardQuery',
  data () {
    return {
      foods: [],
      limit: 7,
      showLimit: 6
    }
  },
  props: {
    query: Object,
    without: String
  },
  computed: {
    headline () {
      if (this.query.category) return this.query.categoryname.value
      return '人気'
    }
  },
  filters: {
  },
  created () {
    this.getFoods()
  },
  mounted () {
  },
  methods: {
    async getFoods () {
      let dbRef = db.collection('food')
      if (this.query.category) {
        dbRef = dbRef.where('category', '==', this.query.category)
      }
      let response = await dbRef.orderBy('famousScore', 'desc').limit(this.limit).get()
      response.forEach(doc => {
        let food = doc.data()
        food.id = doc.id
        if (food.id !== this.without && this.foods.length < this.showLimit) {
          this.foods.push(food)
        }
      })
    }
  },
  components: {
    FoodCardImage
  }
}
</script>

<style>
</style>